import $ from 'jquery';

export default {
  init() {

    //tabs
    $('.detail-tabs li.tab_1').addClass('is-active');
    $('.detail-tabs .tab-titles li').on('click touchend', function () {
      var clicked = $(this).data('tab');
      $('.detail-tabs li.is-active').removeClass('is-active');
      $('.detail-tabs li.' + clicked).addClass('is-active');
    });
  },
};
